import { render } from "./Unauthorized.vue?vue&type=template&id=35461fde"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
script.render = render

export default script